import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiPutFetcher } from '@/common/api/fetcher'
import {
  GetAllConfigsResponse,
  GetAllConfigsVars,
  SystemConfigApiPath,
  UpdateConfigsResponse,
  UpdateConfigsVars
} from '@/common/api/params/systemConfig'

export const useSystemConfigGetApi = () => {
  return useSWR<GetAllConfigsResponse, Response, [string, GetAllConfigsVars]>([
    SystemConfigApiPath.GET_ALL_CONFIGS,
    {}
  ])
}

export const useSystemConfigUpdateApi = (onSuccess?: (r: UpdateConfigsResponse) => void) => {
  return useCallMutation<UpdateConfigsResponse, UpdateConfigsVars>(
    SystemConfigApiPath.UPDATE_CONFIGS,
    { onSuccess },
    apiPutFetcher
  )
}
